// src/components/AmenityCard.tsx

import React from "react";
import { Card, CardContent, CardMedia, Typography, Button, CardActions, CardHeader } from "@mui/material";

interface AmenityCardProps {
    title: string;
    description: string;
    image: string;
    onBook: () => void;
}

const AmenityCard: React.FC<AmenityCardProps> = ({ title, description, image, onBook }) => {
    return (
        <Card sx={{ borderRadius: 3, width: 300, height: 380, margin: 2, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <CardMedia component="img" height="140" image={image} alt={title} />
            <CardHeader title={title} />
            <CardContent>
                <Typography variant="body2" color="text.secondary">
                    {description}
                </Typography>
            </CardContent>
            <CardActions sx={{ justifyContent: 'center' }}>
                <Button variant="contained" color="primary" onClick={onBook}>
                    Book Now
                </Button>
            </CardActions>
        </Card>
    );
};

export default AmenityCard;
